import { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import CustomButton from "../../components/customButton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import usequotationDetail from "../../store/quotation/detailQuotation";
import { joinUrlWithParamsId } from "../../helpers/joinParam";
// import usequotation from "../../store/quotation/storeQuotation";
import { FaArrowLeft } from "react-icons/fa";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { passerCommande, showTransporteurProposition } from "../../lib/apis";
import Loader from "../../components/loader";
import { formatNombre, scrollToTop } from "../../lib/utils";

const DetailQuotation = () => {
  const { t, i18n } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const commande = useLocation().state
  // eslint-disable-next-line
  const [underlineWidth, setUnderlineWidth] = useState(0);
  // eslint-disable-next-line
  const [underlineOffset, setUnderlineOffset] = useState(0);
  const Id = useParams().id;
  const [loader, setLoader] = useState(true)
  const token = localStorage.getItem("token");
  const [orderDetails, setOrderDetail] = useState<any>()
  const [transporteurs, setTransporteurs] = useState<any>()
  const [load, setLoad] = useState(true)
  const [errorMessage, setErrorMessage] = useState<string>()

  const { fetchquotationDetail } = usequotationDetail();

  useEffect(() => {
    scrollToTop()
  }, [])

  useEffect(() => {
    if (Id) {
      fetchquotationDetail(Id);
    }
  }, [Id, fetchquotationDetail]);
  const navigate = useNavigate();
  const navRefs = useRef<(HTMLDivElement | null)[]>([]);

  // eslint-disable-next-line
  const handleNavClick = (index: number) => {
    setActiveIndex(index);
  };
  const updateTransporteur = async () => {
    const currentLanguage = i18n.language
    console.log(currentLanguage)
    try {
      const { data } = await axios.get(`${showTransporteurProposition}/${commande.quotation_id}/proposals`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      console.log("transporteur", data.data)
      setTransporteurs(data.data)
    } catch (error: any) {
      if (error.response.data) {
        if (currentLanguage === "fr") {
          setErrorMessage(error.response.data.message)
        } else {
          setErrorMessage(error.response.data.messageE)
        }
      }

      console.log(error)
    } finally {
      setLoad(false)
    }
  }
  useEffect(() => {
    updateTransporteur()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commande.order_id, i18n.language])

  const updateOrderDetail = async () => {
    setLoader(true)
    try {
      const { data } = await axios.get(`${passerCommande}/${commande.order_id}/details`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      setOrderDetail(data)
      console.log("orderDetails", data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoader(false)
    }
  }
  useEffect(() => {
    updateOrderDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const currentNavRef = navRefs.current[activeIndex];
    if (currentNavRef) {
      setUnderlineWidth(currentNavRef.offsetWidth);
      setUnderlineOffset(currentNavRef.offsetLeft);
    }
  }, [activeIndex]);

  if (loader || load) {
    return <Loader />;
  }

  return (
    <div className="w-full">
      {/* Header */}
      <div
        className="w-full min-h-[30px] h-[239px] relative"
        style={{ backgroundImage: `url('/bio.svg')` }}
      >
        <div className="bg-black opacity-60 absolute top-0 bottom-0 left-0 right-0 z-10"></div>
        <div className="relative z-20 flex flex-col items-center justify-between pt-5 pb-8 h-full px-4">
          <h2 className="text-white text-[27px] font-normal w-full text-start">
            {t('quotation.myRequests')}
          </h2>

        </div>
      </div>
      <div className="flex flex-row mt-10 items-center justify-start w-full ml-5">

        <Breadcrumb />
      </div>

      {/* Quotation Detail */}
      <div className="px-5 py-5 flex flex-col gap-3">
        <h2 className="font-normal text-[13px]">
          {t('quotation.ordersCount')}:{commande.order_id}
        </h2>
        <div className="border-grey border-[1px] rounded-[5px]">
          <div className="bg-softGrey rounded-[5px] py-3 px-5">
            <ul className="w-full flex justify-between">
              <li>
                {t('quotation.requestSentOn')}
                <br />
                {new Date(orderDetails?.created_at).toLocaleDateString()}
              </li>
              <li>
                <span className="text-grey text-sm font-normal">
                  {t('quotation.product')}:
                </span>
                <span> {orderDetails?.orderDetails.length + orderDetails.another_orders.length}</span>
              </li>
              <li>
                <span>{t('quotation.orderNumber')}</span>
                <br />
                <span className="text-primary text-sm font-normal">
                  {t('quotation.orderId', { id: orderDetails?.order_id })}:{orderDetails?.order_id}
                </span>
              </li>
            </ul>
          </div>

          {/* Product List */}
          <div className="px-5 py-3">
            <h3 className="font-normal text-[13px]">{t('quotation.products')}</h3>
            <ul>
              {orderDetails?.orderDetails.map((product: any, index: any) => (
                <li key={index} className="py-2 border-b border-grey">
                  <span className="text-sm font-normal">
                    {product.product_name}
                  </span>{" "}
                  : {product.quantity}  * {formatNombre(product.price)} F
                </li>
              ))}
            </ul>
          </div>
          {/* Product List */}
          <div className="px-5 py-3">
            <h3 className="font-normal text-[13px]">{t('quotation.another_orders')}</h3>
            <ul>
              {orderDetails?.another_orders.map((product: any, index: any) => (
                <li key={index} className="py-2 border-b border-grey">
                  <span className="text-sm font-normal">
                    {product.another_product_name}
                  </span>{" "}
                  {product.another_product_quantity} /  {product.another_product_type}
                </li>
              ))}
            </ul>
          </div>

          {/* Proposals */}
          <div className="py-3 px-5">
            <h3 className="text-[12px] font-normal">
              {t('quotation.carrierProposals')}: {transporteurs?.length}
            </h3>
            <div className="flex w-full gap-3">
              {transporteurs?.users.map((user: any, index: any) => (
                <div
                  key={user.user_id}
                  className="max-w-[250px] min-w-[134px] min-h-[171px] py-1 px-2 flex flex-col items-center gap-1"
                  style={{ boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)" }}
                >
                  <div className="w-full flex justify-end">
                    <span className="text-grey text-[6px] font-normal">
                      {t('quotation.timeAgo', { minutes: 5 })}
                    </span>
                  </div>
                  <div className="max-w-[61px] min-w-[61px] max-h-[61px] min-h-[61px] rounded-full bg-grey">
                    <img
                      className="w-full h-full object-cover"
                      src={user.profile_image_url}
                      alt="user"
                    />
                  </div>
                  <div className="flex flex-col items-center">
                    <span className="text-[10px]">{user.name}</span>
                    <span className="text-[8px]">{user.city}</span>
                    <span className="text-primary text-[10px]">
                      {formatNombre(user.proposed_price)} F
                    </span>
                    <span className="text-[15px] text-center">{user.justification}</span>
                    <span
                      className="underline text-[10px]"
                      onClick={() =>
                        navigate(
                          joinUrlWithParamsId(
                            "/detail_trans/:id",
                            user.proposal_id
                          ),
                          {
                            state: JSON.stringify({
                              image: user.profile_image_url ? user.profile_image_url : "",
                              name: user.name,
                              id: user.user_id,
                              price: formatNombre(user.proposed_price)
                            })
                          }
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {t('quotation.viewDetails')}
                    </span>
                  </div>
                  <div className="flex gap-2 w-full justify-center items-center">
                    <CustomButton
                      className="bg-primary text-white px-2 py-1 text-[15px]"
                      onClick={() =>
                        navigate(
                          joinUrlWithParamsId(
                            "/paiement_trans/:id",
                            user.proposal_id
                          ),
                          {
                            state: {
                              quotationId: user.quotation_id,
                              transporteurId: user.user_id,
                              price: user.proposed_price,
                              name: user.name,
                              justification: user.justification
                            }
                          }
                        )
                      }
                    >
                      <span>{t('quotation.pay')}</span>
                    </CustomButton>
                    {/* <CustomButton className="bg-third text-black px-2 py-1 text-[15px]">
                      <span>{t('quotation.proposal')}</span>
                    </CustomButton> */}
                  </div>
                </div>
              ))}
              <div className=" text-center text-red-500" >{errorMessage}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailQuotation;